import OwaOtherMailboxConfiguration from 'owa-service/lib/contract/OwaOtherMailboxConfiguration';
import getOtherMailboxConfigurationOperation from 'owa-service/lib/operation/getOtherMailboxConfigurationOperation';

/**
 * Service to get the shared folders information. Please note that this operation is not aware of account yet,
 * meaning the operation shall be carried for the logged in account. Whenever we want to support this for
 * the connected account we can add the userIdentity context.
 */
export default function getOtherMailboxConfiguration(): Promise<OwaOtherMailboxConfiguration> {
    return getOtherMailboxConfigurationOperation({});
}
